'use client';

import Footer from './_components/global/footer';
import { ZocBotState } from '@/app/(zoc)/zoc/components/zocBotState';

export default function GlobalError({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <main className="md:relative box-border flex-1">
          <div className="h-[calc(100vh-80px)] overflow-auto mx-auto w-full max-w-4xl relative flex flex-col md:flex-row items-center justify-center">
            <div className="pt-40 md:pt-0 my-4 md:my-10">
              <ZocBotState
                botImage="/icons/something_wrong.svg"
                textTitle="This page does not exist"
                text="The page you are looking for could not be found."
                showHomepageButton={true}
              />
            </div>

            <Footer className="md:absolute bottom-0 md:bottom-6 w-full" />
          </div>
        </main>
      </body>
    </html>
  );
}
